import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const positionApi = {
  modifyMargin(params) {
    const {type, ...query} = params;
    return http.post(type === 'PerpetualV2' ? API_URLS.G_POSITION_MARGIN_MODIFY : API_URLS.POSITION_MARGIN_MODIFY, {query});
  },
  modifyLeverage(params) {
    const {type, ...query} = params;
    return http.put(type === 'PerpetualV2' ? API_URLS.POSITION_LEVERAGE_V2 : API_URLS.POSITION_LEVERAGE, {query});
  },
  modifyRiskLimit(params) {
    const {type, ...query} = params;
    return http.put(type === 'PerpetualV2' ? API_URLS.G_POSITION_RISK_LIMIT : API_URLS.POSITION_RISK_LIMIT, {query});
  },
  switchPositionMode(query) {
    return http.put(API_URLS.G_POSITION_SWITCH_POS_MODE, {query});
  },
  switchPositionMode2(query) {
    return http.put(API_URLS.G_POSITION_SWITCH_POS_MODE2, {query});
  },
  getClosedPositions(query) {
    return http.get(API_URLS.POSITION_CLOSED_LIST_V2, {query});
  },
};
